// Installation vs Service department split (2026-10-09, customer: duty list "filter to be
// with Installation and Service", duty report "still mixed up with Installation and Service
// ... once Service is clicked only show that"). A work item's sourceType decides it:
// SALES_ORDER work is an installation; complaints and service visits are service.
export const DEPT_ALL = "";
export const DEPT_INSTALLATION = "INSTALLATION";
export const DEPT_SERVICE = "SERVICE";

export const DEPT_OPTIONS = [
  { value: DEPT_ALL, label: "All" },
  { value: DEPT_INSTALLATION, label: "Installation" },
  { value: DEPT_SERVICE, label: "Service" },
];

export const deptOf = (sourceType) => (sourceType === "SALES_ORDER" ? DEPT_INSTALLATION : DEPT_SERVICE);

export const inDept = (dept, sourceType) => !dept || deptOf(sourceType) === dept;

export const deptLabel = (dept) => DEPT_OPTIONS.find((o) => o.value === dept)?.label || "All";
